export const environment = {
  production: false,
  // apiHost: "http://qa-apiitracking.iconflux.info",
  apiHost: "https://dev-apiitracking.iconflux.info",
  // apiHost:"https://qa-apiitracking.itracking.asia",
  // apiHost: "http://192.168.196.85:4444",
  platform_header: "WEB",
  otp_type:"EMAIL", //EMAIL | MOBILE
  register_type: "PWD", // PWD | OTP
  api_key:'c2b974a7-70b2-4996-8dd2-50341d230992'
};
